import { stringify } from "../../util/querystring-util";
import { restResourceRequester } from "../rest-resource-requester";
import { GetComponentsRequest } from "./get-components/GetComponentsRequest";
import { GetComponentsResponse } from "./get-components/GetComponentsResponse";
import { UpdateComponentsDeletionFlagsRequest } from "./update-components-deletion-flags/UpdateComponentsDeletionFlagsRequest";
import { UpdateComponentsDeletionFlagsResponse } from "./update-components-deletion-flags/UpdateComponentsDeletionFlagsResponse";

interface ComponentsRestResource {
  getComponents(request: GetComponentsRequest): Promise<GetComponentsResponse>;
  updateComponentsDeletionFlags(
    request: UpdateComponentsDeletionFlagsRequest,
  ): Promise<UpdateComponentsDeletionFlagsResponse>;
}

const REST_RESOURCE_NAME = "/components";

/**
 * GET /components/{rootComponentId}
 */
const getComponents = restResourceRequester<
  GetComponentsRequest,
  GetComponentsResponse
>("GET", (request) => {
  const queryParameters = {
    dipByRgn: request.dipByRgn,
  };
  return `${REST_RESOURCE_NAME}/${request.rootCpntId}?${stringify(
    queryParameters,
  )}`;
});

/**
 * PUT /components/deletionFlags
 */
const updateComponentsDeletionFlags = restResourceRequester<
  UpdateComponentsDeletionFlagsRequest,
  UpdateComponentsDeletionFlagsResponse
>(
  "PUT",
  (request) => {
    return `${REST_RESOURCE_NAME}/deletionFlags`;
  },
  (request) => JSON.stringify(request),
);

export const componentsRestResource: ComponentsRestResource = {
  getComponents: getComponents,
  updateComponentsDeletionFlags: updateComponentsDeletionFlags,
};
